import React, { useState, useRef, createRef, useEffect } from "react"
import { Link } from "gatsby"
import {
  NoticeWizardServiceTypeRefinement,
  NoticeWizardStateRefinement,
} from "components/page-components/Ausschreibungsdienste/notice-wizard/refinement-components"
import {
  WizardHits,
  CustomWizardStats,
} from "components/page-components/Ausschreibungsdienste/notice-wizard/hits"
import { NoticeWizardProgress } from "components/page-components/Ausschreibungsdienste/notice-wizard/utils"
import { InstantSearch, Configure } from "react-instantsearch-dom"
import algoliasearch from "algoliasearch/lite"

export const NoticeWizard = ({ in_bfz_article = false }) => {
  const [wizard_step, set_wizard_step] = useState(0)
  const proceed = () => set_wizard_step(wizard_step + 1)
  const go_back = () => set_wizard_step(wizard_step - 1)
  const [now_unix] = useState(Date.now() / 1000)

  const wizard_refs = useRef(Array.from({ length: 3 }).map(() => createRef()))
  const [current_wizard_ref, set_current_wizard_ref] = useState(null)

  useEffect(() => {
    set_current_wizard_ref(wizard_refs.current[wizard_step])
  }, [wizard_step])

  const searchClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_APP_KEY
  )

  const all_states = [
    "Baden-Württemberg",
    "Bayern",
    "Berlin",
    "Brandenburg",
    "Bremen",
    "Hamburg",
    "Hessen",
    "Mecklenburg-Vorpommern",
    "Niedersachsen",
    "Nordrhein-Westfalen",
    "Rheinland-Pfalz",
    "Saarland",
    "Sachsen",
    "Sachsen-Anhalt",
    "Schleswig-Holstein",
    "Thüringen",
  ]

  const [current_wizard_state_refinement, set_current_wizard_state_refinement] =
    useState(all_states)

  const [
    current_wizard_service_type_refinement,
    set_current_wizard_service_type_refinement,
  ] = useState("Bauleistungen")

  let more_hits_link = `/ausschreibungsdienste#demosearch-box&category=${current_wizard_service_type_refinement}${current_wizard_state_refinement.map(
    (state) => `&bundesland=${state}`
  )}`

  const wizard_refinement_components = [
    {
      Component: NoticeWizardServiceTypeRefinement,
      props: {
        proceed,
        current_wizard_service_type_refinement,
        set_current_wizard_service_type_refinement,
      },
    },
    {
      Component: NoticeWizardStateRefinement,
      props: {
        in_bfz_article,
        current_wizard_state_refinement,
        set_current_wizard_state_refinement,
        all_states,
      },
    },
  ]

  return (
    <div>
      <NoticeWizardProgress {...{ wizard_step }} />
      <div
        className="is-clipped"
        style={{
          transition: "all .3s ease",
          display: "grid",
          maxHeight: !!current_wizard_ref
            ? current_wizard_ref?.current?.clientHeight + 75
            : undefined,
          minHeight: 200,
        }}
      >
        {wizard_refinement_components.map(({ Component, props }, index) => {
          return (
            <div
              key={"wizard_choice-" + index}
              className=""
              style={{
                transition: "all .3s ease",
                gridArea: "1/1",
                position: "relative",
                opacity: wizard_step === index ? "1" : "0",
                visibility: wizard_step === index ? "visible" : "hidden",
                transform: `translateX(${-30 * (wizard_step - index)}%)`,
              }}
            >
              <Component
                {...{
                  wizard_ref: wizard_refs.current[index],
                  ...props,
                }}
              />
              {wizard_step < 2 ? (
                <div className="is-flex px-3 mt-5">
                  <div className="ml-auto">
                    {!!wizard_step ? (
                      <button
                        className="button is-mitternachtsblau is-outlined mr-3 has-text-weight-bold"
                        onClick={go_back}
                      >
                        Zurück
                      </button>
                    ) : null}
                    {wizard_step === 2 ? (
                      <Link
                        to={more_hits_link}
                        className="button is-mitternachtsblau"
                      >
                        Mehr Ergebnisse
                      </Link>
                    ) : (
                      <button
                        className="button is-mitternachtsblau has-text-weight-bold"
                        onClick={proceed}
                      >
                        Weiter
                      </button>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          )
        })}

        {wizard_step > 0 ? (
          <InstantSearch
            {...{
              indexName: process.env.GATSBY_IS,
              searchClient,
            }}
          >
            <Configure
              {...{
                hitsPerPage: 4,
                attributesToRetrieve: [
                  "RefIDStringBI",
                  "ServiceType",
                  "ServiceTypeName",
                  "TitelOnline",
                  "ZoneOfRequestName",
                ],
                filters: `public_preview:true AND ValidUntil>${now_unix} AND categories.lvl0:${current_wizard_service_type_refinement} AND (Bundesland:${current_wizard_state_refinement.join(
                  " OR Bundesland:"
                )})`,
              }}
            />

            <div
              className=""
              style={{
                transition: "all .3s ease",
                gridArea: "1/1",
                position: "relative",
                opacity: wizard_step === 2 ? "1" : "0",
                visibility: wizard_step === 2 ? "visible" : "hidden",
                transform: `translateX(${-30 * (wizard_step - 2)}%)`,
              }}
            >
              <div
                {...{
                  ref: wizard_refs.current[wizard_refinement_components.length],
                }}
              >
                <WizardHits />
              </div>

              {wizard_step === 2 ? (
                <div className="is-flex px-3 mt-5">
                  <div className="mr-auto is-hidden-mobile">
                    <CustomWizardStats {...{ more_hits_link }} />
                  </div>
                  <div className="ml-auto">
                    {!!wizard_step ? (
                      <button
                        className="button is-mitternachtsblau is-outlined mr-3 has-text-weight-bold"
                        onClick={go_back}
                      >
                        Zurück
                      </button>
                    ) : null}
                    {wizard_step === 2 ? (
                      <Link
                        to={more_hits_link}
                        className="button is-mitternachtsblau"
                      >
                        Mehr Ergebnisse
                      </Link>
                    ) : (
                      <button
                        className="button is-mitternachtsblau has-text-weight-bold"
                        onClick={proceed}
                      >
                        Weiter
                      </button>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          </InstantSearch>
        ) : null}
      </div>

      <hr className="is-semi-slim has-background-mitternachtsblau-10" />
    </div>
  )
}
